interface Box {
  height: number,
  width: number,
  positionChecked: boolean,
}

export class ItemBox {
  itemBoxes: Box [];
  lastUpdateIndex: number | undefined | null;

  constructor() {
    this.itemBoxes = [];
  }

  setBox(index, height, width) {
    this.itemBoxes[index] = { height, width, positionChecked: false };
    if (this.lastUpdateIndex == null || index <= this.lastUpdateIndex) {
      this.lastUpdateIndex = index;
    }
  }

  checked(index) {
    this.itemBoxes[index].positionChecked = true;
  }

  getBox(index) {
    if (this.itemBoxes[index]) return this.itemBoxes[index];
    return ({ height: null, width: null, positionChecked: false });
  }
}
